// extracted by mini-css-extract-plugin
module.exports = {"tag":"Tag-module--tag--3lbvw","default":"Tag-module--default--2AqCm","primary":"Tag-module--primary--1gLy7","secondary":"Tag-module--secondary--2APn-"};